import { ICellRendererParams } from "ag-grid-community";
import { X } from "lucide-react";
import React from "react";

import { IgTooltip } from "@intelligems/ig-theme";
import { FullAgencyDto } from "@intelligems/ig-types";
import { AgencyCustomerDto } from "@intelligems/ig-types/dtos/agency-customers";
import { IconButton, useTheme } from "@mui/material";
import { useDeleteAgencyCustomer } from "@src/api/agency-customers/delete-agency-customer";
import { AreYouSure } from "@src/components/Popover/AreYouSure";

export const DeleteColumn = (
  params: ICellRendererParams<AgencyCustomerDto>
) => {
  const deleteCustomerGroup = useDeleteAgencyCustomer(params.data!.agencyId);
  const context = params.context as { agency: FullAgencyDto };
  const theme = useTheme();
  const handleYesClick = () => {
    if (params.data) {
      deleteCustomerGroup.mutate({
        body: undefined,
        queryParams: undefined,
        pathParams: {
          id: params.data.id,
        },
      });
    }
  };

  const hoverText = "Are you sure?";
  const yesMessage = "Yes, delete";

  if (!params.data?.id) {
    return null;
  }

  const isCustomerInUse = context.agency.subscriptions.some(
    (s) =>
      s.stripeCustomerId === params.data!.stripeCustomerId &&
      s.items.some((i) => i.stripeProductLinks.length > 0)
  );

  if (isCustomerInUse) {
    return (
      <IgTooltip
        title={
          isCustomerInUse
            ? "An organization is assigned to this customer's subscription"
            : ""
        }
      >
        <span>
          <IconButton disabled={true}>
            <X size={16} />
          </IconButton>
        </span>
      </IgTooltip>
    );
  }

  return (
    <AreYouSure
      enabled={true}
      keyId={"delete-customer-group"}
      buttonText={"Cancel"}
      isLoading={deleteCustomerGroup.isPending}
      onYesClick={handleYesClick}
      message={hoverText}
      yesMessage={yesMessage}
    >
      <IconButton disabled={isCustomerInUse}>
        <X size={16} color={theme.igIconColors.error} />{" "}
      </IconButton>
    </AreYouSure>
  );
};
